import { Href } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { Description, List, Note, Title } from './elements'

export const AtsIdealdisc = () => {
  return (
    <>
      <Title>
        {i18n.t(
          'app_store_v2.app_integrations.dev_ats_ideal_disc_integration.description_view.title_1'
        )}
      </Title>
      <Description>
        {i18n.t(
          'app_store_v2.app_integrations.dev_ats_ideal_disc_integration.description_view.description_1'
        )}
      </Description>
      <Note>
        {i18n.t(
          'app_store_v2.app_integrations.dev_ats_ideal_disc_integration.description_view.description_4'
        )}
      </Note>
      <Title>
        {i18n.t(
          'app_store_v2.app_integrations.dev_ats_ideal_disc_integration.description_view.title_2'
        )}
      </Title>
      <Description>
        {i18n.t(
          'app_store_v2.app_integrations.dev_ats_ideal_disc_integration.description_view.description_2.section_1'
        )}
        <List>
          {i18n.tView(
            'app_store_v2.app_integrations.dev_ats_ideal_disc_integration.description_view.description_2.section_2',
            {
              idealdisc_url: (
                <Href
                  href={'https://idealdisc.com.br'}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                >
                  idealDisc
                </Href>
              ),
            }
          )}
        </List>
        <List>
          {i18n.t(
            'app_store_v2.app_integrations.dev_ats_ideal_disc_integration.description_view.description_2.section_3'
          )}
        </List>
      </Description>
      <Title>
        {i18n.t(
          'app_store_v2.app_integrations.dev_ats_ideal_disc_integration.description_view.title_3'
        )}
      </Title>
      <Description>
        <List>
          {i18n.tView(
            'app_store_v2.app_integrations.dev_ats_ideal_disc_integration.description_view.description_3.credits',
            {
              idealdisc_url: (
                <Href
                  href={'https://idealdisc.com.br'}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                >
                  idealDisc
                </Href>
              ),
            }
          )}
        </List>
        <List>
          {i18n.t(
            'app_store_v2.app_integrations.dev_ats_ideal_disc_integration.description_view.description_3.section_2'
          )}
        </List>
        <List>
          {i18n.t(
            'app_store_v2.app_integrations.dev_ats_ideal_disc_integration.description_view.description_3.section_3'
          )}
        </List>
        <List>
          {i18n.t(
            'app_store_v2.app_integrations.dev_ats_ideal_disc_integration.description_view.description_3.section_4'
          )}
        </List>
      </Description>
    </>
  )
}
